import { ROUTES } from '../constants';

const EVENTS = {
  addInterestsRecommendationToLibrary: 'onAddToLibraryFromInt',
  addRecommendationToLibrary: 'onAddToLibraryFromRec',
  confirmTerminateAccount: 'onConfirmTerminateAccount',
  continue: 'onContinue',
  deselectInterestItem: 'onInterestDeselect',
  forgotPassword: 'onForgotPassword',
  removeLibraryItem: 'onRemoveFromLibrary',
  resendBack: 'onResendBack',
  resendVerification: 'onResendVerification',
  selectLibraryItem: 'onSelectContent',
  selectLibraryView: 'onSelectContentType',
  selectLibraryDiscover: 'onSelectDiscover',
  selectInterestItem: 'onInterestSelect',
  selectInterestOnboardItem: 'onInterestOnboardSelect',
  selectProfileView: 'onSelectView',
  selectInterestsRecommendationsItem: 'onSelectContentInt',
  selectRecommendationsItem: 'onSelectContentRec',
  skip: 'skip',
  submit: 'onSubmit',
  terminateAccount: 'onTerminateAccount',
  userAuthenticated: 'userAuthenticated',
  userSignOut: 'userSignOut',
};

// Load up routes in an object to be keyed off of the URL
const ROUTE_CONFIG = {};
Object.values(ROUTES).forEach((route) => {
  const { analytics, nestedRoutes, url } = route;
  ROUTE_CONFIG[url] = analytics;
  if (nestedRoutes)
    Object.values(nestedRoutes).forEach((nestedRoute) => {
      ROUTE_CONFIG[`${url}${nestedRoute.url}`] = nestedRoute.analytics;
    });
});

export { EVENTS, ROUTE_CONFIG };
